import axios from 'axios';
import qs from 'qs';
import apis from './api';
import router from '@/router';
import store from '@/store'
let Base64 = require('js-base64').Base64
// let token = Base64.decode(basejm);


axios.defaults.baseURL = '/api';
// console.log(basejm)
//创建axios实例
var instance = axios.create({
	// baseURL: config.baseURL,
	timeout: 100000,
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
	},
	transformRequest: [function(data = {}) {
		//在向服务器发送前，修改请求数据
		return data instanceof FormData ? data : qs.stringify(data)
	}],
	withCredentials: true
})
// 添加响应拦截器
instance.interceptors.response.use(function(response) {
	const responseData = response.data;
	// console.log(responseData)
	if (responseData.code == 0 || responseData.code == 200) {
		//返回自定义信息
		return Promise.resolve(responseData);
	} else if (responseData.code == -1) {
		router.replace({
			name: 'signin',
			query: {
				redirect: router.currentRoute.fullPath
			}
		})
		// router.push('/signin')
	} else {
		return Promise.reject(responseData);
	}
}, function(error) {
	//提示
	// message.error('服务器无响应')
	//响应
	return Promise.reject(error);
});

const fetch = function(axiosInstance, apiMap) {

	let http = {}
	//填充http
	Object.keys(apiMap).forEach(requestMethod => {
		const method = apiMap[requestMethod]
		Object.keys(method).forEach(api => {
			http[api] = data => {
				// console.log(store.state.user)
				let basejm
				if (store.state.user) {
					basejm = store.state.user.access_token;
				}
				let params = '?store_id=1&_version=2.8.9&_platform=pc'
				if (basejm) {
					params += '&access_token=' + basejm;
				}
				return axiosInstance({
					url: method[api] + params,
					method: requestMethod,
					[requestMethod.toUpperCase() === 'POST' ? 'data' : 'params']: data
				})
			}
		})
	})
	return http
}

export default fetch(instance, apis)
